const activeObjectUrls = new Set<string>();

export function registerObjectUrl(url: string): void {
  activeObjectUrls.add(url);
}

export function revokeObjectUrl(url: string | null | undefined): void {
  if (!url) return;
  if (activeObjectUrls.delete(url)) {
    URL.revokeObjectURL(url);
  }
}

/** Revoke image bytes held by mounted views during logout/auth changes. */
export function revokeAllObjectUrls(): void {
  for (const url of activeObjectUrls) {
    URL.revokeObjectURL(url);
  }
  activeObjectUrls.clear();

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('artwork-object-urls-revoked'));
  }
}
